<template>
  <div v-if="viewTypeTab === 'desktopViewTab'">
    <v-expansion-panels v-model="getPromoPanel" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-title>Message</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsTitleMessage :model="model" :actions="actions" :app="app" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Size & Position</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="widget-config-size">
            <RfInputWithMeasures v-model="widgetWidth" :measures="measures" label="Width" />
            <RfInputWithMeasures v-model="widgetHeight" :measures="measures" label="Height" />
          </div>
          <div class="widget-config-size second-row-wdg">
            <RfInputWithMeasures
              v-model="widgetMessageWdth"
              :measures="measures"
              label="Message Width"
            />
          </div>
          <div class="banner-config-size" style="padding-top: 15px">
            <v-select
              v-model="horizontalPosition"
              variant="outlined"
              hideDetails
              density="compact"
              label="Widget Horizontal Position"
              :items="Object.values(HorizontalPositions)"
              itemTitle="text"
            />
            <v-select
              v-model="verticalPosition"
              variant="outlined"
              hideDetails
              density="compact"
              label="Widget Vertical Position"
              :items="Object.values(VerticalPositions)"
              itemTitle="text"
            />
          </div>
          <div class="banner-config-size">
            <RfInputWithMeasures
              v-model="xPosOffset"
              :measures="measuresOffset"
              :label="offsetXLabel"
              :disabled="offsetXDisabled"
            />
            <RfInputWithMeasures
              v-model="yPosOffset"
              :measures="measuresOffset"
              :label="offsetYLabel"
            />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel
        v-if="model.device_type === DefaultDeviceOptions.web.value && model.path_type === 'widget'"
      >
        <v-expansion-panel-title>Pin To</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPinToConfig :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>User Interaction</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionButtons :actions="actions" :model="model" showCloseOptions />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Form</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionFieldSet :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === 'web'">
        <v-expansion-panel-title>Consent Checkbox</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionConsent :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Close Timer</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsBehavior :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Background</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionImageUpload :actions="actions" :model="model" />
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel v-if="model.device_type === DefaultDeviceOptions.web.value">
        <v-expansion-panel-title>CSS</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="promo-design-group">
            <RfPromoCustomCSS :actions="actions" />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel
        v-if="model.device_type === DefaultDeviceOptions.web.value && app.flags.paywalls"
      >
        <v-expansion-panel-title>Paywall</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPaywallConfig :actions="actions" :model="model" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Device Metadata</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsMetadata :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div v-else>
    <v-expansion-panels v-model="getPromoPanel" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-title>CONFIGURATION</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsMobileWeb :app="app" :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Size</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="widget-config-size" style="margin-bottom: 18px">
            <v-text-field
              v-model.trim="actions.rf_mobile_width"
              variant="outlined"
              density="compact"
              persistentPlaceholder
              hideDetails
              label="Width"
              placeholder="e.g.: 300px"
            />
            <v-text-field
              v-model.trim="actions.rf_mobile_height"
              variant="outlined"
              density="compact"
              persistentPlaceholder
              hideDetails
              label="Height"
              placeholder="e.g.: 300px"
            />
          </div>
          <v-text-field
            v-model.trim="actions.rf_mobile_message_width"
            variant="outlined"
            density="compact"
            persistentPlaceholder
            hideDetails
            label="Message Width"
            placeholder="e.g.: 300px"
          />
          <div class="banner-config-size mt-4">
            <v-select
              v-model="mobileVerticalPosition"
              variant="outlined"
              hideDetails
              density="compact"
              label="Widget Vertical Position"
              :items="Object.values(VerticalPositions)"
              itemTitle="text"
            />
            <RfInputWithMeasures
              v-model="yPosOffsetMobile"
              :measures="measuresOffset"
              :label="mobileOffsetYLabel"
            />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === DefaultDeviceOptions.web.value">
        <v-expansion-panel-title>CSS</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPromoCustomCSS :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script setup>
import { computed, ref, watchEffect } from "vue";
import RfRetentionActionsTitleMessage from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsTitleMessage.vue";
import RfRetentionActionsBehavior from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsBehavior.vue";
import RfRetentionButtons from "@/components/RfPathCreate/RfRetentionActions/RfRetentionButtons.vue";
import RfRetentionActionsMobileWeb from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsMobileWeb.vue";
import RfPromoCustomCSS from "@/components/RfPromotions/RfPromoCustomCSS.vue";
import RfRetentionFieldSet from "@/components/RfPathCreate/RfRetentionActions/RfRetentionFieldSet.vue";
import RfRetentionConsent from "@/components/RfPathCreate/RfRetentionActions/RfRetentionConsent.vue";
import RfRetentionImageUpload from "@/components/RfPathCreate/RfRetentionActions/components/RfRetentionImageUpload.vue";
import RfInputWithMeasures from "@/components/legacy/RfInputWithMeasuresLegacy.vue";
import RfRetentionActionsMetadata from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsMetadata.vue";
import RfPaywallConfig from "@/components/RfPathCreate/RfRetentionActions/RfPaywallConfig.vue";
import RfPinToConfig from "@/components/RfPathCreate/RfRetentionActions/RfPinToConfig.vue";
import { getPosition } from "@/utils/prompts/promptHelpers";
import { DefaultDeviceOptions } from "@/utils/constants/DevicesConstants";
import { HorizontalPositions, VerticalPositions } from "@/utils/constants/PositionConstants";
import {
  DEFAULT_MEASURES,
  DEVICES_MEASURES,
  ROKU_MEASURES,
  useCSSProperty,
  WEB_MEASURES,
} from "@/utils/composables/useCSSProperty";

const props = defineProps({
  actions: { type: Object, required: true },
  model: { type: Object, required: true },
  app: { type: Object, required: true },
  viewTypeTab: { type: String, default: "desktopViewTab" },
});

const getPromoPanel = ref([0]);
const { variable: widgetWidth } = useCSSProperty(() => props.actions, "rf_widget_width");
const { variable: widgetHeight } = useCSSProperty(() => props.actions, "rf_widget_height");
const { variable: widgetMessageWdth } = useCSSProperty(
  () => props.actions,
  "rf_settings_text_container_max_width",
);
const measures = computed(() =>
  props.model.device_type === DefaultDeviceOptions.web.value ? WEB_MEASURES : DEFAULT_MEASURES,
);

const mobileWidgetPosition = computed(() => getPosition(props.actions, true));
const mobileVerticalPosition = ref(mobileWidgetPosition.value.y);
const { variable: yPosOffsetMobile } = useCSSProperty(
  () => props.actions,
  "rf_mobile_banner_position_offset_y",
);
const widgetPosition = computed(() => getPosition(props.actions));
const horizontalPosition = ref(widgetPosition.value.x);
const verticalPosition = ref(widgetPosition.value.y);
const { variable: xPosOffset } = useCSSProperty(() => props.actions, "rf_banner_position_offset_x");
const { variable: yPosOffset } = useCSSProperty(() => props.actions, "rf_banner_position_offset_y");

watchEffect(
  () =>
    (props.actions.rf_widget_position = `${verticalPosition.value}_${horizontalPosition.value}`),
);

watchEffect(
  () =>
    (props.actions.rf_mobile_widget_position = `${mobileVerticalPosition.value}_${HorizontalPositions.center.value}`),
);

const measuresOffset = computed(() => {
  if (props.model.device_type === DefaultDeviceOptions.roku_os.value) return ROKU_MEASURES;
  if (props.model.device_type === DefaultDeviceOptions.web.value) return WEB_MEASURES;
  if (
    [
      DefaultDeviceOptions.android_os.value,
      DefaultDeviceOptions.android_tv.value,
      DefaultDeviceOptions.ios.value,
      DefaultDeviceOptions.tv_os.value,
    ].includes(props.model.device_type)
  )
    return DEVICES_MEASURES;
  return DEFAULT_MEASURES;
});

const offsetXLabel = computed(_ => `${HorizontalPositions[widgetPosition.value.x].text} Padding`);
const offsetYLabel = computed(_ => `${VerticalPositions[widgetPosition.value.y].text} Padding`);
const mobileOffsetYLabel = computed(
  () => `${VerticalPositions[mobileWidgetPosition.value.y].text} Padding`,
);
const offsetXDisabled = computed(() =>
  props.actions.rf_widget_position.includes(HorizontalPositions.center.value),
);
</script>

<style lang="scss">
.widget-config-size {
  display: flex;
  gap: 10px;
  &.second-row-wdg {
    padding-top: 15px;
  }
  > div {
    width: 50%;
  }
}
</style>
